import { useTranslation } from 'react-i18next';

import { POS_MODELS } from '@/modules/backoffice/constants';

import styles from './step-model.module.css';

import type { ISelectedModel } from '../../terminal-operation-drawer.type';

interface StepModelProps {
  selectedModel: ISelectedModel | null;
  onSelectModel: (model: ISelectedModel) => void;
}

export const StepModel = ({ selectedModel, onSelectModel }: StepModelProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.title}>
          {t('backoffice.terminalsDrawerStepModelTitle')}
        </span>
        <span className={styles.description}>
          {t('backoffice.terminalsDrawerStepModelDescription')}
        </span>
      </div>

      <div className={styles.grid}>
        {POS_MODELS.map((model) => (
          <button
            key={model.id}
            type="button"
            className={[
              styles.card,
              selectedModel?.id === model.id ? styles['card--selected'] : '',
            ].join(' ')}
            onClick={() => onSelectModel(model)}
          >
            <span className={styles['card-name']}>{model.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
